import React, { useState } from "react";
import { Select, DatePicker } from "antd";
import moment from "moment";

const { Option } = Select;

const ExpRepeater = ({ ExpInputFields, setExpInputFields, disabled, designationOptions }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleFormChange = (index, event) => {
    let data = [...ExpInputFields];
    if (event.target.name === "last_salary") {
      data[index][event.target.name] = event.target.value.replace(/\D/g, "");
    } else {
      data[index][event.target.name] = event.target.value;
    }
    setExpInputFields(data);
  };

  const handleDesignationChange = (index, value) => {
    let data = [...ExpInputFields];
    data[index].designation = value || "";
    setExpInputFields(data);
  };

  const handleDateChange = (index, name, val) => {
    let data = [...ExpInputFields];
    data[index][name] = val ? val.format("YYYY-MM-DD") : "";
    setExpInputFields(data);
  };

  const removeFields = (index) => {
    let data = [...ExpInputFields];
    data.splice(index, 1);
    setExpInputFields(data);
  };

  return (
    <>
      {ExpInputFields.map((input, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
          <div
            onFocus={() => setActiveIndex(index)}
            onBlur={() => setActiveIndex(null)}
            style={{ flex: 1, border: `1px solid ${activeIndex === index ? "#1D1D1D" : "#e0e0e0"}`, borderRadius: "8px", padding: "14px 18px 6px 18px", background: "#fff", transition: "border-color 0.15s" }}
          >
            <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
              <span style={{ fontWeight: 600, fontSize: "13px", color: "#1D1D1D", display: "flex", alignItems: "center", gap: "7px" }}>
                <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: "#0bc698", flexShrink: 0 }} />
                Work Experience {index + 1}
              </span>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="float-input-wrap mb-3">
                  <input
                    type="text"
                    id={`org_title_${index}`}
                    placeholder=" "
                    disabled={disabled}
                    name="organization_title"
                    value={input.organization_title}
                    onChange={(e) => handleFormChange(index, e)}
                  />
                  <label htmlFor={`org_title_${index}`}>Organization Title</label>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className={`float-select-wrap mb-3 ${input.designation ? "has-value" : ""}`}>
                  <label>Designation</label>
                  <Select
                    disabled={disabled}
                    value={input.designation || undefined}
                    onChange={(val) => handleDesignationChange(index, val)}
                    placeholder=""
                    style={{ width: "100%" }}
                    showSearch
                    allowClear={!disabled}
                    filterOption={(inputVal, option) =>
                      String(option.children).toLowerCase().includes(inputVal.toLowerCase())
                    }
                  >
                    {(designationOptions || []).map((opt) => (
                      <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className={`float-select-wrap mb-3 ${input.start_date ? "has-value" : ""}`}>
                  <label>Start Date</label>
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD-MM-YYYY"
                    placeholder=""
                    value={input.start_date ? moment(input.start_date, "YYYY-MM-DD") : null}
                    onChange={(val) => handleDateChange(index, "start_date", val)}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className={`float-select-wrap mb-3 ${input.end_date ? "has-value" : ""}`}>
                  <label>End Date</label>
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD-MM-YYYY"
                    placeholder=""
                    value={input.end_date ? moment(input.end_date, "YYYY-MM-DD") : null}
                    onChange={(val) => handleDateChange(index, "end_date", val)}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="float-input-wrap mb-3">
                  <input
                    type="text"
                    id={`last_salary_${index}`}
                    placeholder=" "
                    disabled={disabled}
                    name="last_salary"
                    value={input.last_salary}
                    onChange={(e) => handleFormChange(index, e)}
                  />
                  <label htmlFor={`last_salary_${index}`}>Last Drawn Salary</label>
                </div>
              </div>
            </div>
          </div>

          {ExpInputFields.length > 1 && !disabled && (
            <button
              type="button"
              onClick={() => removeFields(index)}
              style={{ background: "#f0f0f0", border: "none", cursor: "pointer", borderRadius: "8px", width: "42px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#555" }}
            >
              <i className="uil-trash-alt" style={{ fontSize: "18px" }} />
            </button>
          )}
        </div>
      ))}
    </>
  );
};

export default ExpRepeater;
